var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-l-transparent border-2 animate-spin rounded-full",class:[_vm.sizeClass, _vm.borderClass]})
}
var staticRenderFns = []

export { render, staticRenderFns }